import { Affix, Button, Stack, Transition } from "@mantine/core";
import { useWindowScroll } from "@mantine/hooks";
import { openContextModal } from "@mantine/modals";
import { IconArrowUp } from "@tabler/icons-react";
import { useTranslation } from "next-i18next";
import {
  useBoard,
  useIsBoardAdmin,
  useIsBoardReferee,
  useSelfMember,
} from "../../common/boards/board.hooks";
import { Swords } from "../../common/icons/swords";
import { useMatchStore } from "../../common/stores/match.store";
import { trackEvent } from "../../common/analytics";

const FloatAddMatch = () => {
  const { t } = useTranslation();
  const resetFormValues = useMatchStore((s) => s.resetFormValues);
  const { board } = useBoard();
  const isAdmin = useIsBoardAdmin();
  const isRef = useIsBoardReferee();
  // console.log("isAdmin :", isAdmin);
  const selfMember = useSelfMember();
  // console.log("selfMember :", selfMember);
  const canAdd = isAdmin || isRef || (selfMember && board?.ownMatches);
  // console.log("canAdd :", canAdd);
  const [scroll, scrollTo] = useWindowScroll();
  const openAddMatch = () => {
    resetFormValues();
    trackEvent("open_modal_add_match", { board: board?._id });
    openContextModal({
      title: t("addMatch"),
      modal: "addMatch",
      fullScreen: true,
      onClose: () => resetFormValues(),
      innerProps: {
        creatable: isAdmin || (isRef && board?.refereeAddMembers),
        memberId: isRef ? null : selfMember?._id,
      },
    });
  };
  return (
    <Affix position={{ bottom: 100, right: 20 }} zIndex={10}>
      <Stack>
        <Transition transition="slide-up" mounted={scroll.y > 0}>
          {(transitionStyles) => (
            <Button
              variant="light"
              radius="xl"
              leftSection={<IconArrowUp size={16} />}
              style={transitionStyles}
              onClick={() => scrollTo({ y: 0 })}
            >
              {t("scrollTop")}
            </Button>
          )}
        </Transition>
        {canAdd && (
          <Button radius="xl" leftSection={<Swords />} onClick={openAddMatch}>
            {t("addMatch")}
          </Button>
        )}
      </Stack>
    </Affix>
  );
};
export default FloatAddMatch;
